import React, { useEffect, useState, useRef, } from 'react'
import useAuth from '../../auth/UseAuth';

import { NotificationToast } from '../../classess/main/notifications/notificationToast';

import {
    getResponse, settings, styles, isUndNullEmp, awaitDelayAsync, getDtRowIndex, isUndNull, lodash, setSeparatorsNumbers, LoadingSection,
    getUserRoles, handleResponseMessageAsync, getLanguageObj, notificationsToastGetAsync, notificationsToastShowAsync, dataTableLanguaje
} from '../../helpers/main';
import Menu from '../main/Menu';
import HomeService from '../../services/home/HomeService';
import { GlobalFormats } from '../../classess/main/globalFormats';
import TableIndex from '../main/TableIndex';

const $ = window.jqGlobal || window.jQuery;

const { app, html, icons, images, labels, timers } = settings;

const currentMethod = 'Home';

export default function Home({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const userRole = !isUndNullEmp({ data: auth, subMethod: currentMethod })?.result &&
        !isUndNullEmp({ data: auth?.user, subMethod: currentMethod })?.result &&
        !isUndNullEmp({ data: auth?.user?.role, subMethod: currentMethod })?.result ?
        auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result : settings?.roles?.anonymous;

    // let userRolesArr = getRolesType();
    const userRoles = getUserRoles({ userRole: userRole, subMethod: currentMethod })?.result;

    const [showData, setShowData] = useState(false);
    const [process, setProcess] = useState({
        showLoading: false,
        resumeCustomers: false,
        resumeValuesGeneral: false,
        resumeValuesAmount: true,
        resumeServicesGeneral: false,
        resumeServicesDetails: true,
    });

    const isMount = useRef(true);
    const dtCustomersRowIdRef = useRef(0);

    let customersObj = {
        customer: {
            id: 0,
            name: '',
        },
        rowId: 0,
        classNameHighLighting: 'bg bg-info',
    };
    const [dtCustomersObj, setDtCustomersObj] = useState(customersObj);

    const resumeCustomers = {
        id: 'dtCompanies',
        processCtrls: {
            button: {
                id: 'btnResumeCustomers',
                className: 'btn btn-sm btn-outline-info',
                label: labels?.customers?.[languageObj?.id],
            },
        },
        style: {
            fontSize: 13,
        }
    };

    const resumeServices = {
        ids: {
            services01Id: 'services01',
            services02Id: 'services02',
            services03Id: 'services03',
            services04Id: 'services04',
            services05Id: 'services05',
        },
        style: {
            fontSize: 13,
            image: {
                height: 35,
                width: 35,
            },
            imageCheckFalse: {
                alt: 'imageCheckFalse',
                height: 16,
                src: images?.icons?.toggleOff,
                width: 29,
            },
            imageCheckTrue: {
                alt: 'imageCheckTrue',
                height: 16,
                src: images?.icons?.toggleOn,
                width: 29,
            },
        },
    };

    const [resumeValues, setResumeValues] = useState({
        requirements: [],
        statementAccounts: [],
        userCompanyCustomers: [],
    });

    let customerServiceObj = {
        backupReviews: {},
        dataCenters: {},
        devices: {},
        domainHostings: {},
        remoteConnections: {},
    };

    let customerServicesObj = {
        backupReviews: [],
        dataCenters: [],
        devices: [],
        domainHostings: [],
        remoteConnections: [],
    };

    const [customers, setCustomers] = useState([]);
    const [customerService, setCustomerService] = useState(customerServiceObj);
    const [customerServices, setCustomerServices] = useState(customerServicesObj);

    const zeroValueStr = setSeparatorsNumbers({
        number: 0.00,
        withDecimals: true,
        consoleLogErrorShow: true,
        subMethod: currentMethod,
    })?.result;

    let customerValuesObj = {
        balanceTotals: {
            documents: 0.00,
            documentsStr: zeroValueStr,
            others: 0.00,
            othersStr: zeroValueStr,
        },
        requirements: [],
        userCompanyCustomers: [],
    };
    const [customerValues, setCustomerValues] = useState(customerValuesObj);
    //#endregion variables

    //#region methods
    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            $(`#${resumeCustomers?.id}`)?.DataTable({
                autoWidth: false,
                columns: [
                    {
                        title: labels?.id?.[languageObj?.id],
                        render: (data, type, row) => {
                            let dataNew = '';
                            dataNew = `<a style='text-decoration:none; color:inherit;' href='#companies'>${data}</a>`;
                            return dataNew;
                        },
                        orderable: false,
                        searchable: false,
                        visible: false,
                        width: '0%',
                    },
                    {
                        title: labels?.name?.[languageObj?.id],
                        render: (data, type, row) => {
                            let dataNew = '';
                            dataNew = `<a style='text-decoration:none; color:inherit;' href='#companies'>${data}</a>`;
                            return dataNew;
                        },
                        width: '100%',
                    },
                ],
                data: [],
                destroy: true,
                info: false,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                lengthChange: false,
                pageLength: 5,
                order: [[0, 'asc']],
                ordering: false,
                paging: true,
                responsive: true,
                searching: false,
                fnDrawCallback: () => {
                    $(`#${resumeCustomers?.id} thead`)?.remove();
                },
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let rowId = 0;
            const customersDt = $(`#${resumeCustomers?.id}`)?.DataTable();
            //#endregion variables

            //#region process
            $(`#${resumeCustomers?.id} tbody`).on('click', 'tr', 'td', async function (e) {
                rowId = getDtRowIndex({ dtId: resumeCustomers?.id, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    $(customersDt?.row(dtCustomersRowIdRef.current)?.node()).removeClass(dtCustomersObj?.classNameHighLighting);
                    $(customersDt?.row(rowId)?.node())?.addClass(dtCustomersObj?.classNameHighLighting);
                    dtCustomersRowIdRef.current = rowId;

                    setDtCustomersObj({
                        ...dtCustomersObj,
                        customer: {
                            ...dtCustomersObj?.customer,
                            id: $(customersDt?.row(rowId)?.data())?.[0] || 0,
                            name: $(customersDt?.row(rowId)?.data())?.[1] || '',
                        },
                        rowId: rowId,
                    });

                    $(`#${resumeCustomers?.processCtrls?.button?.id}`)?.attr('data-type', 1);
                    $(`#${resumeCustomers?.processCtrls?.button?.id}`)?.trigger('click');
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        customers = [],
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let rowsDataDt = [];
            //#endregion variables

            //#region process
            customers?.map((customer) => (
                rowsDataDt.push([
                    customer?.id,
                    customer?.name,
                ])
            ));

            $(`#${resumeCustomers?.id}`)?.DataTable()?.rows?.add(rowsDataDt)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const loadDataAsync = async ({
        e = {},
        _dtCustomersObj = dtCustomersObj?.customer?.id <= 0 ? customersObj : dtCustomersObj,
        _customers = customers?.length > 0 ? customers : [],
        _services = (customerServices?.backupReviews?.length > 0 ||
            customerServices?.dataCenters?.length > 0 ||
            customerServices?.devices?.length > 0 ||
            customerServices?.domainHostings?.length > 0 ||
            customerServices?.remoteConnections?.length > 0) ? customerServices : customerServicesObj,
        consoleLogErrorShow = true,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'loadDataAsync';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            const customerObj = {
                model: {},
                html: '',
            };
            const servicesObj = {
                backupReviewObj: {
                    model: {},
                },
                dataCentersObj: {
                    model: {},
                },
                devicesObj: {
                    model: {},
                },
                domainHostingsObj: {
                    model: {},
                },
                remoteConnectionsObj: {
                    model: {},
                },
            };
            const valuesObj = {
                balanceTotals: customerValuesObj?.balanceTotals,
                requirements: [],
                statementAccounts: [],
                userCompanyCustomers: customerValuesObj?.userCompanyCustomers,
            };
            const processType = parseInt(parseFloat($(`#${resumeCustomers?.processCtrls?.button?.id}`)?.attr('data-type')));
            //#endregion variables

            if (!isUndNullEmp({ data: e?.preventDefault, subMethod: currentMethod, })?.result) {
                e?.preventDefault?.();
            }

            if (processType === 0) {
                setProcess(prev => ({
                    ...prev,
                    resumeValuesGeneral: false,
                    resumeServicesGeneral: false,
                }));
            } else if (processType === 1) {
                setProcess(prev => ({
                    ...prev,
                    resumeValuesAmount: false,
                    resumeServicesDetails: false,
                }));
            }

            //#region customer
            customerObj.model = _customers?.find(({ id, }) => id === _dtCustomersObj?.customer?.id) || {};
            customerObj.html = `${customerObj?.model?.name}`;
            //#endregion customer

            //#region resumevalues
            valuesObj.statementAccounts = resumeValues?.statementAccounts?.filter(({ co_Cli }) => co_Cli === customerObj?.model?.secundaryId) || [];

            //#region get totals
            response = lodash?.sum({ data: valuesObj?.statementAccounts || [], key: 'saldo_Doc', consoleLogErrorShow: consoleLogErrorShow, subMethod: currentMethod, });
            if (response?.isSuccess && !response?.isWarning) {
                valuesObj.balanceTotals.documents = response?.result || 0.00;
                valuesObj.balanceTotals.documentsStr = setSeparatorsNumbers({
                    number: valuesObj.balanceTotals.documents,
                    withDecimals: true,
                    consoleLogErrorShow: consoleLogErrorShow,
                    subMethod: currentMethod,
                })?.result;
            } else if (!consoleLogErrorShow) {
                return response;
            }

            response = lodash?.sum({ data: valuesObj?.statementAccounts || [], key: 'saldo_Nde1', consoleLogErrorShow: consoleLogErrorShow, subMethod: currentMethod, });
            if (response?.isSuccess && !response?.isWarning) {
                valuesObj.balanceTotals.others = response?.result || 0.00;
                valuesObj.balanceTotals.othersStr = setSeparatorsNumbers({
                    number: valuesObj.balanceTotals.others,
                    withDecimals: true,
                    consoleLogErrorShow: consoleLogErrorShow,
                    subMethod: currentMethod,
                })?.result;
            } else if (!consoleLogErrorShow) {
                return response;
            }
            //#endregion get totals

            //#region user company customers
            valuesObj.userCompanyCustomers = resumeValues?.userCompanyCustomers?.filter(({ customerId }) => customerId === customerObj?.model?.id) || [];
            valuesObj.userCompanyCustomers = lodash?.unique({ data: valuesObj?.userCompanyCustomers, key: 'userId', subMethod: currentMethod, })?.result || [];
            //#endregion user company customers

            //#region requirements
            valuesObj.requirements = resumeValues?.requirements?.filter(({ customerId }) => customerId === customerObj?.model?.id) || [];
            //#endregion requirements

            setCustomerValues({
                ...customerValues,
                balanceTotals: {
                    ...customerValues?.balanceTotals,
                    documents: valuesObj?.balanceTotals?.documents,
                    documentsStr: valuesObj?.balanceTotals?.documentsStr,
                    others: valuesObj?.balanceTotals?.others,
                    othersStr: valuesObj?.balanceTotals?.othersStr,
                },
                requirements: valuesObj?.requirements,
                userCompanyCustomers: valuesObj?.userCompanyCustomers,
            });

            await awaitDelayAsync({ delayTime: timers?.oneSecond, });

            if (processType === 0) {
                setProcess(prev => ({
                    ...prev,
                    resumeValuesGeneral: true,
                    resumeServicesGeneral: true,
                }));
            } else if (processType === 1) {
                setProcess(prev => ({
                    ...prev,
                    resumeValuesAmount: true,
                    resumeServicesDetails: true,
                }));
            }
            //#endregion resumevalues

            //#region resumeservices
            servicesObj.backupReviewObj.model = _services?.backupReviews?.find(({ customerId, }) => customerId === customerObj?.model?.id) || {};
            servicesObj.dataCentersObj.model = _services?.dataCenters?.find(({ docCustomerId, }) => docCustomerId === customerObj?.model?.secundaryId) || {};
            servicesObj.devicesObj.model = _services?.devices?.find(({ customerId, }) => customerId === customerObj?.model?.id) || {};
            servicesObj.domainHostingsObj.model = _services?.domainHostings?.find(({ docCustomerId, }) => docCustomerId === customerObj?.model?.secundaryId) || {};
            servicesObj.remoteConnectionsObj.model = _services?.remoteConnections?.find(({ docCustomerId, }) => docCustomerId === customerObj?.model?.secundaryId) || {};

            setCustomerService({
                ...customerService,
                backupReviews: servicesObj?.backupReviewObj?.model,
                dataCenters: servicesObj?.dataCentersObj?.model,
                devices: servicesObj?.devicesObj?.model,
                domainHostings: servicesObj?.domainHostingsObj?.model,
                remoteConnections: servicesObj?.remoteConnectionsObj?.model,
            });

            await awaitDelayAsync({ delayTime: timers?.oneSecond, });

            if (processType === 0) {
                setProcess(prev => ({
                    ...prev,
                    resumeServicesGeneral: true,
                }));
            } else if (processType === 1) {
                setProcess(prev => ({
                    ...prev,
                    resumeServicesDetails: true,
                }));
            }
            //#endregion resumeservices
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, languageId: languageObj?.id });
            }
        }
        return response;
    }

    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let customersData = [];
            let notificationToastsData = [];
            let notificationsToastObj = {
                ...NotificationToast?.getClass({}, false),
                controller: app?.views?.main?.home,
                method: app?.views?.main?.index,
            };
            let customerServicesData = customerServicesObj;
            let dtCustomerData = dtCustomersObj;
            //#endregion variables

            setProcess(prev => ({
                ...prev,
                resumeCustomers: false,
                resumeValuesGeneral: false,
                resumeServicesGeneral: false,
            }));
            setShowData(true);

            if (auth?.isLoged({ subMethod: currentMethod })?.result &&
                !userRoles?.isService) {
                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region notificationtoast (get)
                response = await notificationsToastGetAsync({
                    data: notificationsToastObj,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;

                notificationToastsData = response?.result?.toasts || [];
                //#endregion notificationtoast (get)

                //#region show toasts
                response = await notificationsToastShowAsync({
                    data: notificationToastsData,
                    languageId: languageObj?.id,
                    window: window,
                    document: document,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion show toasts

                //#region home (get data)
                response = await HomeService.getHomeDataAsync({
                    auth: auth,
                    languageId: languageObj?.id,
                });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion home (get data)

                //#region set data
                customersData = response?.result?.customers || [];
                setCustomers(customersData);
                customerServicesData = response?.result?.services || [];
                setCustomerServices(customerServicesData);
                setResumeValues({
                    ...resumeValues,
                    requirements: response?.result?.requirements || [],
                    statementAccounts: response?.result?.statementAccounts || [],
                    userCompanyCustomers: response?.result?.userCompanyCustomers || [],
                });
                //#endregion set data

                //#region set datatable
                if (!isUndNullEmp({ data: customersData, subMethod: currentMethod })?.result &&
                    customersData.length > 0) {
                    response = setDataInDataTable({ customers: customersData, subMethod: currentMethod, });
                    if (!response?.isSuccess || response?.isWarning) return;

                    $($(`#${resumeCustomers?.id}`)?.DataTable()?.row(dtCustomersRowIdRef.current)?.node())?.addClass(dtCustomerData?.classNameHighLighting);
                    dtCustomerData.id = customersData?.[0]?.id;
                    dtCustomerData.name = customersData?.[0]?.name;

                    setDtCustomersObj({
                        ...dtCustomersObj,
                        customer: {
                            ...dtCustomersObj.customer,
                            id: dtCustomerData?.id,
                            name: dtCustomerData?.name,
                        },
                    });
                }

                await awaitDelayAsync({ delayTime: timers?.oneSecond, });
                setProcess(prev => ({ ...prev, resumeCustomers: true, }));
                //#endregion set datatable

                //#region set services
                $(`#${resumeCustomers?.processCtrls?.button?.id}`)?.attr('data-type', 0);
                $(`#${resumeCustomers?.processCtrls?.button?.id}`)?.trigger('click');
                //#endregion set services
            } else {
                setShowData(false);

                //#region notificationtoast (get)
                response = await notificationsToastGetAsync({
                    data: {
                        ...notificationsToastObj,
                        isAuthenticated: false,
                    },
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;

                notificationToastsData = response?.result?.toasts || [];
                //#endregion notificationtoast (get)

                setShowData(true);

                //#region show toasts
                response = await notificationsToastShowAsync({
                    data: notificationToastsData,
                    languageId: languageObj?.id,
                    window: window,
                    document: document,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion show toasts
            }
        } catch (ex) {
            setShowData(false);
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning) {
                setShowData(false);
            }
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, languageId: languageObj?.id });
            }
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName={app?.views?.main?.home} process={app?.views?.main?.home} languageObj={languageObj} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.home?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item active text-primary'>{labels?.home?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result &&
                            !userRoles?.isService ?
                            <div hidden={!showData}>
                                {/* Small boxes (Stat box) */}
                                <div className='row'>
                                    {/* Tarjeta 1: Balance Documentos (Warning) */}
                                    <div className='col-lg-3 col-6 px-2 pb-3'>
                                        <div className='card border-0 shadow-lg p-3 bg-white h-100' style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='resumeValues1'
                                                className='overlay dark text-white'
                                                hidden={process?.resumeValuesGeneral}
                                                languageId={languageObj?.id} />
                                            <div className='d-flex align-items-center'>
                                                <div className='rounded-circle d-flex align-items-center justify-content-center mr-3 shadow-sm'
                                                    style={{
                                                        backgroundColor: 'rgba(255, 193, 7, 0.15)',
                                                        width: '50px',
                                                        height: '50px',
                                                        minWidth: '50px'
                                                    }}>
                                                    <i className={`${icons?.ions?.bag} text-warning`} style={{ fontSize: '1.2rem' }}></i>
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <span className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>
                                                        {labels?.balanceDocuments?.[languageObj?.id]}
                                                    </span>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>
                                                        {process?.resumeValuesGeneral ?
                                                            process?.resumeValuesAmount ?
                                                                <>{customerValues?.balanceTotals?.documentsStr}</>
                                                                :
                                                                <LoadingSection
                                                                    alt='resumeValueAmount1'
                                                                    showText={false}
                                                                    hidden={process?.resumeValuesAmount}
                                                                    languageId={languageObj?.id} />
                                                            :
                                                            <>{zeroValueStr}</>
                                                        }
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Tarjeta 2: Balance Otros (Danger) */}
                                    <div className='col-lg-3 col-6 px-2 pb-3'>
                                        <div className='card border-0 shadow-lg p-3 bg-white h-100' style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='resumeValues2'
                                                className='overlay dark text-white'
                                                hidden={process?.resumeValuesGeneral}
                                                languageId={languageObj?.id} />
                                            <div className='d-flex align-items-center'>
                                                <div className='rounded-circle d-flex align-items-center justify-content-center mr-3 shadow-sm'
                                                    style={{
                                                        backgroundColor: 'rgba(220, 53, 69, 0.15)',
                                                        width: '50px',
                                                        height: '50px',
                                                        minWidth: '50px'
                                                    }}>
                                                    <i className={`${icons?.ions?.cash} text-danger`} style={{ fontSize: '1.2rem' }}></i>
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <span className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>
                                                        {labels?.balanceOthers?.[languageObj?.id]}
                                                    </span>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>
                                                        {process?.resumeValuesGeneral ?
                                                            process?.resumeValuesAmount ?
                                                                <>{customerValues?.balanceTotals?.othersStr}</>
                                                                :
                                                                <LoadingSection
                                                                    alt='resumeValueAmount2'
                                                                    showText={false}
                                                                    hidden={process?.resumeValuesAmount}
                                                                    languageId={languageObj?.id} />
                                                            :
                                                            <>{zeroValueStr}</>
                                                        }
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Tarjeta 3: Usuarios (Info) */}
                                    <div className='col-lg-3 col-6 px-2 pb-3'>
                                        <div className='card border-0 shadow-lg p-3 bg-white h-100' style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='resumeValues3'
                                                className='overlay dark text-white'
                                                hidden={process?.resumeValuesGeneral}
                                                languageId={languageObj?.id} />
                                            <div className='d-flex align-items-center'>
                                                <div className='rounded-circle d-flex align-items-center justify-content-center mr-3 shadow-sm'
                                                    style={{
                                                        backgroundColor: 'rgba(23, 162, 184, 0.15)',
                                                        width: '50px',
                                                        height: '50px',
                                                        minWidth: '50px'
                                                    }}>
                                                    <i className={`${icons?.ions?.people} text-info`} style={{ fontSize: '1.2rem' }}></i>
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <span className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>
                                                        {labels?.users?.[languageObj?.id]}
                                                    </span>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>
                                                        {process?.resumeValuesGeneral ?
                                                            process?.resumeValuesAmount ?
                                                                <>{customerValues?.userCompanyCustomers?.length || 0}</>
                                                                :
                                                                <LoadingSection
                                                                    alt='resumeValueAmount3'
                                                                    showText={false}
                                                                    hidden={process?.resumeValuesAmount}
                                                                    languageId={languageObj?.id} />
                                                            :
                                                            <>{0}</>
                                                        }
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Tarjeta 4: Requerimientos (Success) */}
                                    <div className='col-lg-3 col-6 px-2 pb-3'>
                                        <div className='card border-0 shadow-lg p-3 bg-white h-100' style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='resumeValues4'
                                                className='overlay dark text-white'
                                                hidden={process?.resumeValuesGeneral}
                                                languageId={languageObj?.id} />
                                            <div className='d-flex align-items-center'>
                                                <div className='rounded-circle d-flex align-items-center justify-content-center mr-3 shadow-sm'
                                                    style={{
                                                        backgroundColor: 'rgba(40, 167, 69, 0.15)',
                                                        width: '50px',
                                                        height: '50px',
                                                        minWidth: '50px'
                                                    }}>
                                                    <i className={`${icons?.ions?.list} text-success`} style={{ fontSize: '1.2rem' }}></i>
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <span className='text-muted text-uppercase mb-1' style={{ fontSize: '0.65rem', fontWeight: '800', letterSpacing: '0.8px' }}>
                                                        {labels?.requirements?.[languageObj?.id]}
                                                    </span>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>
                                                        {process?.resumeValuesGeneral ?
                                                            process?.resumeValuesAmount ?
                                                                <>{customerValues?.requirements?.length || 0}</>
                                                                :
                                                                <LoadingSection
                                                                    alt='resumeValueAmount4'
                                                                    showText={false}
                                                                    hidden={process?.resumeValuesAmount}
                                                                    languageId={languageObj?.id} />
                                                            :
                                                            <>{0}</>
                                                        }
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    {/* Left col */}
                                    {/*Customers*/}
                                    <section className='col-lg-6 connectedSortable'>
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='companiesAlt'
                                                className={`overlay dark text-white`}
                                                hidden={process?.resumeCustomers}
                                                languageId={languageObj?.id} />
                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div className='d-flex align-items-center'>
                                                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                            style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <img alt={labels?.companies?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.company}></img>
                                                        </div>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.companies?.[languageObj?.id]}</h5>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-body px-4 pb-4'>
                                                <TableIndex tableId={resumeCustomers?.id} languageObj={languageObj} />

                                                <div className='row'
                                                    hidden={true}>
                                                    <div className='col-12'>
                                                        <button className={resumeCustomers?.processCtrls?.button?.className}
                                                            id={resumeCustomers?.processCtrls?.button?.id}
                                                            onClick={(e) => loadDataAsync({ e: e, subMethod: e?.currentTarget?.id })}
                                                            type='button'>{resumeCustomers?.processCtrls?.button?.label}</button>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* /.card-body */}
                                        </div>
                                    </section>

                                    {/* /.Left col */}

                                    {/* right col (We are only adding the ID to make the widgets sortable)*/}
                                    <section className='col-lg-6 connectedSortable'>
                                        {/*Services*/}
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='companiesAlt'
                                                className={`overlay dark text-white`}
                                                hidden={process?.resumeServicesGeneral}
                                                languageId={languageObj?.id} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div className='d-flex align-items-center'>
                                                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                            style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <img alt={labels?.services?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.services}></img>
                                                        </div>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.services?.[languageObj?.id]}</h5>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body p-0'>
                                                <ul className='products-list product-list-in-card pl-0 pr-0'>
                                                    {/* Backup Reviews */}
                                                    <li id={resumeServices?.ids?.services01Id} className='item border-0 px-4 py-3 border-bottom' style={{ transition: 'background 0.3s' }}>
                                                        <div className='product-img mr-3'>
                                                            <div className='bg-light p-2 rounded shadow-sm d-flex align-items-center justify-content-center' style={{ width: '45px', height: '45px' }}>
                                                                <img src={images?.icons?.backupReviews} alt='servicesBackupReview' style={{ height: '25px', width: '25px' }} />
                                                            </div>
                                                        </div>
                                                        <div className='product-info ml-0'>
                                                            <a href={`#${resumeServices?.ids?.services01Id}`} className='product-title font-weight-bold text-dark' style={{ fontSize: '0.95rem' }}>
                                                                {labels?.backupReviews?.[languageObj?.id]}
                                                                <span className='float-right'>
                                                                    {process?.resumeServicesGeneral ?
                                                                        process?.resumeServicesDetails ?
                                                                            <img alt={resumeServices?.style?.imageCheckTrue?.alt}
                                                                                src={customerService?.backupReviews?.isActive ? resumeServices?.style?.imageCheckTrue?.src : resumeServices?.style?.imageCheckFalse?.src}
                                                                                style={{ height: '48px', width: '48px' }} />
                                                                            :
                                                                            <LoadingSection alt='servicesAlt1' hidden={process?.resumeServicesDetails} showText={false} languageId={languageObj?.id} />
                                                                        :
                                                                        <img alt={resumeServices?.style?.imageCheckFalse?.alt} src={resumeServices?.style?.imageCheckFalse?.src} style={{ height: '48px', width: '48px' }} />
                                                                    }
                                                                </span>
                                                            </a>
                                                            <span className='product-description text-muted' style={{ fontSize: '0.85rem' }}>
                                                                {labels?.servicesTitles?.backupReviews?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </li>

                                                    {/* Data Centers */}
                                                    <li id={resumeServices?.ids?.services02Id} className='item border-0 px-4 py-3 border-bottom' style={{ transition: 'background 0.3s' }}>
                                                        <div className='product-img mr-3'>
                                                            <div className='bg-light p-2 rounded shadow-sm d-flex align-items-center justify-content-center' style={{ width: '45px', height: '45px' }}>
                                                                <img src={images?.icons?.dataCenters} alt='servicesDataCenters' style={{ height: '25px', width: '25px' }} />
                                                            </div>
                                                        </div>
                                                        <div className='product-info ml-0'>
                                                            <a href={`#${resumeServices?.ids?.services02Id}`} className='product-title font-weight-bold text-dark' style={{ fontSize: '0.95rem' }}>
                                                                {labels?.dataCenters?.[languageObj?.id]}
                                                                <span className='float-right'>
                                                                    {process?.resumeServicesGeneral ?
                                                                        process?.resumeServicesDetails ?
                                                                            <img alt={resumeServices?.style?.imageCheckTrue?.alt}
                                                                                src={customerService?.dataCenters?.docNumber && customerService?.dataCenters?.docNumber > 0 ? resumeServices?.style?.imageCheckTrue?.src : resumeServices?.style?.imageCheckFalse?.src}
                                                                                style={{ height: '48px', width: '48px' }} />
                                                                            :
                                                                            <LoadingSection alt='servicesAlt2' hidden={process?.resumeServicesDetails} showText={false} languageId={languageObj?.id} />
                                                                        :
                                                                        <img alt={resumeServices?.style?.imageCheckFalse?.alt} src={resumeServices?.style?.imageCheckFalse?.src} style={{ height: '48px', width: '48px' }} />
                                                                    }
                                                                </span>
                                                            </a>
                                                            <span className='product-description text-muted' style={{ fontSize: '0.85rem' }}>
                                                                {labels?.servicesTitles?.dataCenters?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </li>

                                                    {/* Devices */}
                                                    <li id={resumeServices?.ids?.services03Id} className='item border-0 px-4 py-3 border-bottom' style={{ transition: 'background 0.3s' }}>
                                                        <div className='product-img mr-3'>
                                                            <div className='bg-light p-2 rounded shadow-sm d-flex align-items-center justify-content-center' style={{ width: '45px', height: '45px' }}>
                                                                <img src={images?.icons?.devices} alt='servicesDevices' style={{ height: '25px', width: '25px' }} />
                                                            </div>
                                                        </div>
                                                        <div className='product-info ml-0'>
                                                            <a href={`#${resumeServices?.ids?.services03Id}`} className='product-title font-weight-bold text-dark' style={{ fontSize: '0.95rem' }}>
                                                                {labels?.devices?.[languageObj?.id]}
                                                                <span className='float-right'>
                                                                    {process?.resumeServicesGeneral ?
                                                                        process?.resumeServicesDetails ?
                                                                            <img alt={resumeServices?.style?.imageCheckTrue?.alt}
                                                                                src={customerService?.devices?.id && customerService?.devices?.id > 0 ? resumeServices?.style?.imageCheckTrue?.src : resumeServices?.style?.imageCheckFalse?.src}
                                                                                style={{ height: '48px', width: '48px' }} />
                                                                            :
                                                                            <LoadingSection alt='servicesAlt3' hidden={process?.resumeServicesDetails} showText={false} languageId={languageObj?.id} />
                                                                        :
                                                                        <img alt={resumeServices?.style?.imageCheckFalse?.alt} src={resumeServices?.style?.imageCheckFalse?.src} style={{ height: '48px', width: '48px' }} />
                                                                    }
                                                                </span>
                                                            </a>
                                                            {labels?.servicesTitles?.devices?.[languageObj?.id]}
                                                        </div>
                                                    </li>

                                                    {/* Domain Hostings */}
                                                    <li id={resumeServices?.ids?.services04Id} className='item border-0 px-4 py-3 border-bottom' style={{ transition: 'background 0.3s' }}>
                                                        <div className='product-img mr-3'>
                                                            <div className='bg-light p-2 rounded shadow-sm d-flex align-items-center justify-content-center' style={{ width: '45px', height: '45px' }}>
                                                                <img src={images?.icons?.domainHostings} alt='servicesDomainHostings' style={{ height: '25px', width: '25px' }} />
                                                            </div>
                                                        </div>
                                                        <div className='product-info ml-0'>
                                                            <a href={`#${resumeServices?.ids?.services04Id}`} className='product-title font-weight-bold text-dark' style={{ fontSize: '0.95rem' }}>
                                                                {labels?.domainHostings?.[languageObj?.id]}
                                                                <span className='float-right'>
                                                                    {process?.resumeServicesGeneral ?
                                                                        process?.resumeServicesDetails ?
                                                                            <img alt={resumeServices?.style?.imageCheckTrue?.alt}
                                                                                src={customerService?.domainHostings?.docNumber && customerService?.domainHostings?.docNumber > 0 ? resumeServices?.style?.imageCheckTrue?.src : resumeServices?.style?.imageCheckFalse?.src}
                                                                                style={{ height: '48px', width: '48px' }} />
                                                                            :
                                                                            <LoadingSection alt='servicesAlt4' hidden={process?.resumeServicesDetails} showText={false} languageId={languageObj?.id} />
                                                                        :
                                                                        <img alt={resumeServices?.style?.imageCheckFalse?.alt} src={resumeServices?.style?.imageCheckFalse?.src} style={{ height: '48px', width: '48px' }} />
                                                                    }
                                                                </span>
                                                            </a>
                                                            <span className='product-description text-muted' style={{ fontSize: '0.85rem' }}>
                                                                {labels?.servicesTitles?.domainHostings?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </li>

                                                    {/* Remote Connections */}
                                                    <li id={resumeServices?.ids?.services05Id} className='item border-0 px-4 py-3' style={{ transition: 'background 0.3s' }}>
                                                        <div className='product-img mr-3'>
                                                            <div className='bg-light p-2 rounded shadow-sm d-flex align-items-center justify-content-center' style={{ width: '45px', height: '45px' }}>
                                                                <img src={images?.icons?.remoteConnections} alt='servicesRemoteConnections' style={{ height: '25px', width: '25px' }} />
                                                            </div>
                                                        </div>
                                                        <div className='product-info ml-0'>
                                                            <a href={`#${resumeServices?.ids?.services05Id}`} className='product-title font-weight-bold text-dark' style={{ fontSize: '0.95rem' }}>
                                                                {labels?.remoteConnections?.[languageObj?.id]}
                                                                <span className='float-right'>
                                                                    {process?.resumeServicesGeneral ?
                                                                        process?.resumeServicesDetails ?
                                                                            <img alt={resumeServices?.style?.imageCheckTrue?.alt}
                                                                                src={customerService?.remoteConnections?.docNumber && customerService?.remoteConnections?.docNumber > 0 ? resumeServices?.style?.imageCheckTrue?.src : resumeServices?.style?.imageCheckFalse?.src}
                                                                                style={{ height: '48px', width: '48px' }} />
                                                                            :
                                                                            <LoadingSection alt='servicesAlt5' hidden={process?.resumeServicesDetails} showText={false} languageId={languageObj?.id} />
                                                                        :
                                                                        <img alt={resumeServices?.style?.imageCheckFalse?.alt} src={resumeServices?.style?.imageCheckFalse?.src} style={{ height: '48px', width: '48px' }} />
                                                                    }
                                                                </span>
                                                            </a>
                                                            <span className='product-description text-muted' style={{ fontSize: '0.85rem' }}>
                                                                {labels?.servicesTitles?.remoteConnectionDNS?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>

                                        </div>{/* /.card */}
                                    </section>{/* right col */}

                                </div>{/* /.row (main row) */}
                            </div>
                            :
                            <div hidden={!showData}>
                                <div className='row text-center align-items-center justify-content-center'>
                                    <div className='text-center'>
                                        <img alt='appLogo' src={images?.appLogo} style={styles?.appLogoHome} />
                                    </div>
                                    <div>
                                        <h5 className='display-5'>
                                            {settings?.app?.title}
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </section >
            </div>
        </div>
    )
}